export default __webpack_public_path__ + "static/media/tfp-menu.99b93ca0.png";